import React from "react";
import "./ScrollButton.scss";
import { Link } from "react-scroll";

class ScrollButton extends React.Component {
  render() {
    return (
      <div className="scroll-button-container">
        <Link
          activeClass="active"
          to="firstInsideContainer"
          spy={true}
          smooth={true}
          duration={250}
          containerId="containerElement"
          style={{
            display: "inline-block",
            margin: 0,
            position: "absolute",
            bottom: 75,
            right: 0,
            zIndex: 9,
            cursor: "pointer"
          }}
        >
          <div id="scroll-button">
            <img src="/img/arrow_up/arrow-up.svg" alt="Ir arriba" />
          </div>
        </Link>
      </div>
    );
  }
}

export default ScrollButton;
